import AppLayout from "../../components/AppLayout";
import TableUserConnections from "../../components/tables/TableUserConnections";
import useUserConnections from "../../hooks/pages/admin/useUserConnections";

const UserConnections = () => {
  const { isLoading, userConnections } = useUserConnections();

  return (
    <AppLayout
      isLoading={isLoading}
      title="Panel de Administrador"
      tabType="admin"
      tab={1}
    >
      <div className="row  m-0 p-0">
        <div>
          <TableUserConnections data={userConnections} />
        </div>
      </div>
    </AppLayout>
  );
};

export default UserConnections;
